import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { DonationRequisitionPage } from '@/features/marketPromotion/pages/DonationRequisitionPage';
import { donationRequisitionSearchSchema } from '@/features/marketPromotion/types/marketPromotionP2.types';

export const Route = createFileRoute('/_auth/market-promotion/requisitions')({
  validateSearch: donationRequisitionSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Donation Requisition">
      <Suspense fallback={<PageLoader />}>
        <DonationRequisitionPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
